/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginCredentials
 */
export interface LoginCredentials {
    /**
     * 
     * @type {string}
     * @memberof LoginCredentials
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof LoginCredentials
     */
    password: string;
}

/**
 * Check if a given object implements the LoginCredentials interface.
 */
export function instanceOfLoginCredentials(value: object): value is LoginCredentials {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function LoginCredentialsFromJSON(json: any): LoginCredentials {
    return LoginCredentialsFromJSONTyped(json, false);
}

export function LoginCredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginCredentials {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
    };
}

export function LoginCredentialsToJSON(json: any): LoginCredentials {
    return LoginCredentialsToJSONTyped(json, false);
}

export function LoginCredentialsToJSONTyped(value?: LoginCredentials | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'password': value['password'],
    };
}

